import defaultApi from './defaultApi';

const dashboardApi = {
  dashboard: {
    prefix:
      process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH + '/cloudmonitorings/dashboard',
    SWAGGER: '/v2/api-docs?group=API-v1.0.0',
    API_INFO: {},
    SAMPLE: {}
  }
};
dashboardApi.dashboard = Object.assign(dashboardApi.dashboard, defaultApi);
export default dashboardApi;
